import bodymovin from 'lottie-web';

import arrow from './icons/arrow.json';
import card from './icons/card.json';
import truck from './icons/truck.json';


window.addEventListener('load', function () {

        function loadAnimationAutoPlay(line, lineObject) {
            let parameters = {
                container: line,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: lineObject
            };

            let animation;
            animation = bodymovin.loadAnimation(parameters);
            animation.setDirection(1);
            animation.play();
        }

        function initAnimation(icon_name, animation_json_name) {
            [...document.getElementsByClassName('box__ico ' + icon_name)].forEach((element, index, array) => {
                loadAnimationAutoPlay(array[index], animation_json_name)
            })
        }

        initAnimation("icon-location", arrow)
        initAnimation("icon-payment", card)
        initAnimation("icon-truck", truck)

    }
);
